/**
 * m3 echo Frontend - User Menu Component
 *
 * Dropdown menu showing user info and logout option.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuthStore, useUser, useToken } from '../stores/useAuthStore';
import { authService } from '../services/auth';
import { resetQueryCache } from '../utils/queryClient';

export const UserMenu: React.FC = () => {
  const navigate = useNavigate();
  const user = useUser();
  const token = useToken();
  const { clearAuth } = useAuthStore();

  const handleLogout = async () => {
    try {
      if (token) {
        await authService.logout(token);
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      clearAuth();
      // Logout navigates within the SPA, so the cached responses of the previous
      // identity have to be dropped explicitly before the next login.
      await resetQueryCache();
      navigate('/login');
    }
  };

  if (!user) {
    return null;
  }

  return (
    <ListItemButton
      onClick={handleLogout}
      sx={{
        borderRadius: 1,
        border: '1px solid #e5e7eb',
        color: '#6b7280',
      }}
    >
      <ListItemIcon sx={{ minWidth: 40, color: '#6b7280' }}>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText
        primary="Logout"
        primaryTypographyProps={{
          fontSize: '0.95rem',
          fontWeight: 500,
        }}
      />
    </ListItemButton>
  );
};
